// Frontend: Full updated CandidateFilter component
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  CircularProgress,
  Alert,
  Snackbar,
  TextField,
  Pagination,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Tooltip,
  Chip,
  Container,
  LinearProgress,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Grid,
  Stack,
  FormControlLabel
} from "@mui/material";
import {
  Search,
  Person,
  Email,
  Phone,
  Code,
  WorkHistory,
  Add,
  Visibility,
  Description,
  Info,
  Close,
  AutoAwesome,
  CheckCircle,
  Pending,
  Cancel,
  Schedule,
  AssignmentTurnedIn,
  PersonAdd,
  HowToReg,
  CheckBox,
  CheckBoxOutlineBlank
} from "@mui/icons-material";
import DiscoveryDialog from './DiscoveryDialog'
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const CandidateFilter = () => {
  const [candidates, setCandidates] = useState([]); // Current page candidates
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [filters, setFilters] = useState({ skills: "", experience: "" });
  const [searchTerm, setSearchTerm] = useState("");
  const [availableSkills, setAvailableSkills] = useState([]);
  const [availableJobs, setAvailableJobs] = useState([]);
  const [openAddSkillDialog, setOpenAddSkillDialog] = useState(false);
  const [newSkill, setNewSkill] = useState("");
  const [skillError, setSkillError] = useState("");
  const [resumeLoading, setResumeLoading] = useState(null);
  const [openReferrerDialog, setOpenReferrerDialog] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  
  // AI Shortlisting states
  const [shortlistLoading, setShortlistLoading] = useState(false);
  const [openJobSelectDialog, setOpenJobSelectDialog] = useState(false);
  const [selectedJobForShortlist, setSelectedJobForShortlist] = useState("");
  const [shortlistProgress, setShortlistProgress] = useState("");
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "info"
  });
  
  // Manual Shortlisting states
  const [openManualShortlistDialog, setOpenManualShortlistDialog] = useState(false);
  const [manualShortlistLoading, setManualShortlistLoading] = useState(false);
  const [allFilteredCandidates, setAllFilteredCandidates] = useState([]); // All filtered for manual dialog
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [shortlistMode, setShortlistMode] = useState('ai'); // 'ai' or 'manual'
  
  const [discoverQuery, setDiscoverQuery] = useState("");
const [discoverLoading, setDiscoverLoading] = useState(false);
const [discoverDialogOpen, setDiscoverDialogOpen] = useState(false);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    fetchCandidates(1);
    fetchAvailableJobs();
    fetchAvailableSkills();
  }, []);

  // Refetch on search term change (live search)
  useEffect(() => {
    setCurrentPage(1);
    fetchCandidates(1, filters.skills, filters.experience, searchTerm);
  }, [searchTerm]);

  const fetchCandidates = async (page = 1, skills = "", experience = "", search = "") => {
    setLoading(true);
    setError("");
    try {
      const token = localStorage.getItem('token'); 
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
      
      // Build params for backend filtering and pagination
      const params = {
        page: page.toString(),
        limit: itemsPerPage.toString()
      };
      if (skills) params.skills = skills;
      if (experience) params.experience = experience;
      if (search) params.search = search;
      
      const response = await axios.get(`${API_URL}/api/candidates`, { params,
        headers:{
          Authorization: `Bearer ${token}`,
        }
       });
      
      let pageCandidates = response.data.candidates;
      
      // Apply HR completed filter client-side
      const interviewsResponse = await axios.get(`${API_URL}/api/interviews/hr-completed`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          
          }
        }
      );
      const hrCompletedEmails = new Set(interviewsResponse.data.map(interview => 
        interview.candidateEmail || interview.email
      ));
      
      const activeCandidates = pageCandidates.filter(candidate => 
        !hrCompletedEmails.has(candidate.email)
      );
      
      setCandidates(activeCandidates);
      setTotalPages(response.data.pagination ? response.data.pagination.pages : 1);
      setCurrentPage(page);
    } catch (error) {
      // setError("Failed to fetch candidates. Please try again.");
      //console.error("Error fetching candidates:", error);
      setCandidates([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };
const handleDiscover = async (searchParams) => {
  setDiscoverLoading(true);
  
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error("No authentication token");
    }
    
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
    
    const response = await axios.post(`${API_URL}/api/resume-sourcing/discover`, {
      ...searchParams,
      limit: 15
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    // Navigate to discovery results page
    navigate("/discovery-results", {
      state: { 
        query: searchParams.job_title, 
        results: response.data,
        searchParams: searchParams
      }
    });
    
  } catch (error) {
    //console.error("Discovery error:", error);
    alert(`Discovery failed: ${error.response?.data?.error || error.message}`);
    throw error;
  } finally {
    setDiscoverLoading(false);
  }
};
  const fetchAvailableJobs = async () => {
    try {
      const token = localStorage.getItem('token'); 
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
      
      // Fetch ALL candidates (no limit/page) for unique jobs
      const params = { company_id };
      const response = await axios.get(`${API_URL}/api/candidates`, { params,
        headers: {
          Authorization: `Bearer ${token}`,
        }
       });
      
      const interviewsResponse = await axios.get(`${API_URL}/api/interviews/hr-completed`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
      const hrCompletedEmails = new Set(interviewsResponse.data.map(interview => 
        interview.candidateEmail || interview.email
      ));
      
      const activeCandidates = response.data.candidates.filter(candidate => 
        !hrCompletedEmails.has(candidate.email)
      );
      
      const uniqueJobs = [...new Set(activeCandidates.map(c => c.positionApplied))].filter(Boolean);
      setAvailableJobs(uniqueJobs);
    } catch (error) {
      //console.error("Error fetching available jobs:", error);
      setAvailableJobs([]);
    }
  };

  const fetchAllFiltered = async (skills = filters.skills, experience = filters.experience, search = searchTerm) => {
    try {
      const token = localStorage.getItem('token'); 
      if (!token) {
        throw new Error("No authentication token found");
      }
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
      
      // Fetch ALL matching filters (no limit/page)
      const params = { company_id };
      if (skills) params.skills = skills;
      if (experience) params.experience = experience;
      if (search) params.search = search;
      
      const response = await axios.get(`${API_URL}/api/candidates`,
         { params ,
        headers:{
          Authorization: `Bearer ${token}`,
        }
      });
      
      const interviewsResponse = await axios.get(`${API_URL}/api/interviews/hr-completed`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
      
      );
      const hrCompletedEmails = new Set(interviewsResponse.data.map(interview => 
        interview.candidateEmail || interview.email
      ));
      
      const activeCandidates = response.data.candidates.filter(candidate => 
        !hrCompletedEmails.has(candidate.email)
      );
      
      return activeCandidates;
    } catch (error) {
      //console.error("Error fetching all filtered candidates:", error);
      return [];
    }
  };

  const fetchAvailableSkills = async () => {
    try {
      const token = localStorage.getItem('token'); 
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
      
      const response = await axios.get(`${API_URL}/api/skills`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
      if (response.data && Array.isArray(response.data)) {
        setAvailableSkills(response.data);
        localStorage.setItem('availableSkills', JSON.stringify(response.data));
      }
    } catch (error) {
      //console.error("Error fetching skills from API:", error);
      const localSkills = localStorage.getItem('availableSkills');
      if (localSkills) {
        try {
          const parsedSkills = JSON.parse(localSkills);
          setAvailableSkills(parsedSkills);
        } catch (parseError) {
          //console.error("Error parsing local skills:", parseError);
          setDefaultSkills();
        }
      } else {
        setDefaultSkills();
      }
    }
  };

  const setDefaultSkills = () => {
    const defaultSkills = [
      "Node", "React", "Python", "Java", "MongoDB", "Express", "JavaScript", 
      "Django", "SQL", "Spring Boot", ".NET", "C#", "Angular", "TypeScript", 
      "PostgreSQL", "Kotlin", "C++", "Blockchain", "Vue.js", "Solidity"
    ];
    setAvailableSkills(defaultSkills);
    localStorage.setItem('availableSkills', JSON.stringify(defaultSkills));
  };

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    fetchCandidates(value, filters.skills, filters.experience, searchTerm);
  };

  const filterCandidates = () => {
    setCurrentPage(1);
    fetchCandidates(1, filters.skills, filters.experience, searchTerm);
  };

  const scheduleInterview = (candidate) => {
    navigate("/interview-scheduling", { 
      state: { 
        name: candidate.name, 
        email: candidate.email,
        phone: candidate.phone,
        positionApplied: candidate.positionApplied || "Not specified",
        skills: candidate.skills.join(", "), 
        experience: `${candidate.experience} years`
      } 
    });
  };

  // const handleViewResume = async (candidate) => {
  //   if (!candidate.resumePath) {
  //     setError("Resume not available for this candidate");
  //     return;
  //   }

  //   setResumeLoading(candidate.email);
  //   try {
  //     const token = localStorage.getItem('token'); 
  //     if (!token) {
  //       alert("No authentication token found. Please log in.");
  //       return;
  //     }
  //     const payload = JSON.parse(atob(token.split('.')[1]));
  //     const company_id = payload.company_id;
      
  //     const response = await axios.get(
  //       `${API_URL}/api/candidates/resume/${candidate.email}`,
  //       { responseType: 'blob' ,
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json"
  //         }
  //       }
  //     );
      
  //     const blob = new Blob([response.data], { type: response.headers['content-type'] });
  //     const url = window.URL.createObjectURL(blob);
  //     window.open(url, '_blank');
      
  //     setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  //   } catch (error) {
  //     //console.error("Error viewing resume:", error);
  //     if (error.response?.status === 404) {
  //       setError("Resume file not found on server");
  //     } else {
  //       setError("Failed to load resume. Please try again.");
  //     }
  //   } finally {
  //     setResumeLoading(null);
  //   }
  // };
  const handleViewResume = async (candidate) => {
    if (!candidate.resumePath) {
      setError("Resume not available for this candidate");
      return;
    }

    // Check if it's an external URL (sourced candidates)
    if (candidate.resumePath.startsWith('http://') || candidate.resumePath.startsWith('https://')) {
      const url = candidate.resumePath;
      if (url.match(/\.(doc|docx|xls|xlsx|ppt|pptx)$/i)) {
        window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`, '_blank');
      } else {
        window.open(url, '_blank');
      }
      return;
    }

    setResumeLoading(candidate.email);
    try {
      const token = localStorage.getItem('token'); 
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }
      
      const response = await axios.get(
        `${API_URL}/api/candidates/resume/${candidate.email}`,
        { responseType: 'blob' ,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
      
      const contentType = response.headers['content-type'];
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      
      if (contentType === 'application/pdf' || contentType.includes('image')) {
        window.open(url, '_blank');
      } else {
        const a = document.createElement('a');
        a.href = url;
        let ext = '.bin';
        if (contentType.includes('wordprocessingml')) ext = '.docx';
        else if (contentType.includes('msword')) ext = '.doc';
        a.download = `resume${ext}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      
      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    } catch (error) {
      if (error.response?.status === 404) {
        setError("Resume file not found on server");
      } else {
        setError("Failed to load resume. Please try again.");
      }
    } finally {
      setResumeLoading(null);
    }
  };
  const handleOpenAddSkillDialog = () => {
    setOpenAddSkillDialog(true);
    setNewSkill("");
    setSkillError("");
  };

  const handleCloseAddSkillDialog = () => {
    setOpenAddSkillDialog(false);
  };

  const handleNewSkillChange = (e) => {
    setNewSkill(e.target.value);
    if (e.target.value.trim() === "") {
      setSkillError("Skill cannot be empty");
    } else if (availableSkills.includes(e.target.value.trim())) {
      setSkillError("This skill already exists");
    } else {
      setSkillError("");
    }
  };

  const handleAddSkill = async () => {
    if (newSkill.trim() === "") {
      setSkillError("Skill cannot be empty");
      return;
    }

    if (availableSkills.includes(newSkill.trim())) {
      setSkillError("This skill already exists");
      return;
    }

    const updatedSkills = [...availableSkills, newSkill.trim()];

    try {
      const token = localStorage.getItem('token'); 
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
      
      await axios.post(`${API_URL}/api/skills`, { skill: newSkill.trim()},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        
       });
      setAvailableSkills(updatedSkills);
      localStorage.setItem('availableSkills', JSON.stringify(updatedSkills));
      setError("");
      handleCloseAddSkillDialog();
    } catch (error) {
      //console.error("Error adding skill to API:", error);
      setAvailableSkills(updatedSkills);
      localStorage.setItem('availableSkills', JSON.stringify(updatedSkills));
      handleCloseAddSkillDialog();
    }
  };

  const handleShowReferrerDetails = (candidate) => {
    setSelectedCandidate(candidate);
    setOpenReferrerDialog(true);
  };

  const handleCloseReferrerDialog = () => {
    setOpenReferrerDialog(false);
    setSelectedCandidate(null);
  };

  // AI Shortlisting functions
  const handleOpenShortlistDialog = () => {
    if (availableJobs.length === 0) {
      alert('No job positions found. Please ensure candidates have applied for positions.');
      return;
    }
    
    if (availableJobs.length === 1) {
      handleAutoShortlist(availableJobs[0]);
    } else {
      setOpenJobSelectDialog(true);
    }
  };

  const handleCloseJobSelectDialog = () => {
    setOpenJobSelectDialog(false);
    setSelectedJobForShortlist("");
    setShortlistProgress("");
  };

  const handleAutoShortlist = async (jobTitle = null) => {
    const jobToShortlist = jobTitle || selectedJobForShortlist;
    
 
    if (!jobToShortlist) {
      alert('Please select a job position');
      return;
    }

    const currentFilters = {
      skills: filters.skills || '',
      experience: filters.experience || ''
    };

    if (!currentFilters.skills && !currentFilters.experience) {
      if (!window.confirm(`No skills/exp filters set. This will shortlist ALL for "${jobToShortlist}". Add filters first?`)) {
        return;
      }
    }

    if (!window.confirm(
      ` AI-Powered Auto-Shortlisting\n\nThis will:\n\n` +
      `1. Analyze filtered candidates for "${jobToShortlist}"\n` +
      `2. Use AI to identify best matches\n` +
      `3. Update database status to "Shortlisted"\n` +
      `4. Send emails to selected candidates\n` +
      `5. Notify hiring manager\n\n` +
      `Filters: Skills="${currentFilters.skills}", Exp="${currentFilters.experience}"\n\n` +
      `Continue?`
    )) {
      return;
    }
  
    setShortlistLoading(true);
    setShortlistProgress(" Initializing AI analysis...");
    handleCloseJobSelectDialog();
  
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('No authentication token found');
      }
      
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
      
    

      const encodedJobTitle = encodeURIComponent(jobToShortlist);

      setShortlistProgress("🔍 AI analyzing candidate profiles...");

      const apiUrl = `${API_URL}/api/candidates/auto-shortlist/${encodedJobTitle}?skills=${encodeURIComponent(currentFilters.skills)}&experience=${encodeURIComponent(currentFilters.experience)}`;
    

      const response = await axios.post(
        apiUrl,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

    
      setShortlistProgress("✅ AI analysis complete! Processing results...");

      const responseData = response.data;
      
      let successMessage = 
        `✅ Shortlisting Complete!\n\n` +
        `🎯 Job Position: ${jobToShortlist}\n\n` +
        `📊 Statistics:\n` +
        `• Total Candidates Reviewed: ${responseData.totalCandidates}\n` +
        `• Candidates Shortlisted: ${responseData.shortlistedCount}\n\n` +
        `💾 Database Updates:\n` +
        `• ${responseData.databaseStatus}\n\n`;

      if (responseData.emailNotifications) {
        successMessage += 
        `📧 Notifications:\n` +
        `• ${responseData.emailNotifications.candidatesNotified} candidates notified\n` +
        `• Emails sent: ${responseData.emailNotifications.successfulEmails}\n` +
        `• Hiring manager notified: ${responseData.emailNotifications.hiringManagerNotified ? 'Yes' : 'No'}\n\n`;
      }

      successMessage += 
        `✨ Next Steps:\n` +
        `• Candidates will respond within 48 hours\n` +
        `• HR team will schedule interviews within 2-3 business days\n\n` +
        `All actions completed!`;

      alert(successMessage);
      
      await fetchCandidates(currentPage, filters.skills, filters.experience, searchTerm);

    } catch (error) {
      //console.error('\n❌ ===== FRONTEND: AI AUTO-SHORTLIST ERROR =====');
      //console.error('Error Type:', error.name);
      //console.error('Error Message:', error.message);
      
      const errorData = error.response?.data;

      // 1. IF PLAN DOES NOT INCLUDE AI (e.g., Basic Plan with 0 tokens)
      if (errorData?.code === "AI_PLAN_UPGRADE_REQUIRED") {
        setAlert({
          open: true,
          message: errorData.message || "AI features are not included in your current plan. Please upgrade to unlock AI.",
          severity: "warning"
        });
        window.dispatchEvent(new CustomEvent("openUpgradeModal", { detail: { feature: "AI Shortlisting" } }));
      } 
      // 2. IF TOKENS ARE EXHAUSTED
      else if (errorData?.code === "AI_TOKENS_EXHAUSTED") {
        setAlert({
          open: true,
          message: `⚠️ ${errorData.message || "You have used all your AI tokens for this billing cycle."}`,
          severity: "warning"
        });
      } 
      else {
        const errorMsg = errorData?.message || error.message || 'Failed to shortlist candidates. Please try again.';
        setAlert({
          open: true,
          message: `❌ ${errorMsg}`,
          severity: "error"
        });
      }
    } finally {
      setShortlistLoading(false);
      setShortlistProgress("");
    }
  };

  // Manual Shortlisting functions
  const handleOpenManualShortlistDialog = async () => {
    if (availableJobs.length === 0) {
      alert('No job positions found. Please ensure candidates have applied for positions.');
      return;
    }
    
    // Fetch ALL filtered candidates for the dialog
    const allCands = await fetchAllFiltered();
    if (allCands.length === 0) {
      alert('No candidates available for shortlisting. Please adjust your filters.');
      return;
    }
    
    setAllFilteredCandidates(allCands);
    setSelectedCandidates([]);
    setSelectAll(false);
    setOpenManualShortlistDialog(true);
  };

  const handleCloseManualShortlistDialog = () => {
    setOpenManualShortlistDialog(false);
    setAllFilteredCandidates([]);
    setSelectedCandidates([]);
    setSelectAll(false);
  };

  const handleSelectCandidate = (email) => {
    setSelectedCandidates(prev => {
      if (prev.includes(email)) {
        return prev.filter(e => e !== email);
      } else {
        return [...prev, email];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedCandidates([]);
    } else {
      const allEligibleEmails = allFilteredCandidates
        .filter(candidate => {
          const statusLower = (candidate.status || '').toLowerCase().trim();
          return !['shortlisted', 'interest confirmed', 'not interested', 'interview scheduled', 'interview completed', 'selected', 'rejected'].includes(statusLower);
        })
        .map(candidate => candidate.email);
      setSelectedCandidates(allEligibleEmails);
    }
    setSelectAll(!selectAll);
  };

  const handleManualShortlist = async () => {
    if (selectedCandidates.length === 0) {
      window.alert('Please select at least one candidate to shortlist.');
      return;
    }

    if (!selectedJobForShortlist) {
      window.alert('Please select a job position for shortlisting.');
      return;
    }

    if (!window.confirm(
      `📋 Manual Shortlisting Confirmation\n\n` +
      `• Job Position: ${selectedJobForShortlist}\n` +
      `• Selected Candidates: ${selectedCandidates.length}\n\n` +
      `This will:\n` +
      `1. Update status to "Shortlisted" for selected candidates\n` +
      `2. Send notification emails to candidates\n` +
      `3. Notify hiring manager\n\n` +
      `Continue?`
    )) {
      return;
    }

    setManualShortlistLoading(true);
    
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }
      
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;

      const response = await axios.post(`${API_URL}/api/candidates/manual-shortlist`, {
        jobTitle: selectedJobForShortlist,
        candidateEmails: selectedCandidates,
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      window.alert(`✅ Manual Shortlisting Complete!\n\n` +
            `• Job: ${selectedJobForShortlist}\n` +
            `• Shortlisted: ${selectedCandidates.length} candidates\n` +
            `• Emails sent: ${response.data.emailNotifications.successfulEmails}\n\n` +
            `Candidates have been notified and hiring manager has been informed.`);

      // Refresh candidate list
      await fetchCandidates(currentPage, filters.skills, filters.experience, searchTerm);
      handleCloseManualShortlistDialog();
      
    } catch (error) {
      //console.error('Manual shortlisting error:', error);
      window.alert(`❌ Manual Shortlisting Failed:\n\n${error.response?.data?.message || error.message}`);
    } finally {
      setManualShortlistLoading(false);
    }
  };

  // Get status chip with color
  const getStatusChip = (status) => {
    const normalizedStatus = status ? status.toLowerCase().trim() : 'pending';
    
    const statusColors = {
      'pending': { 
        color: 'warning', 
        icon: <Pending fontSize="small" />,
        bgcolor: '#fff3e0',
        textColor: '#e65100'
      },
      'shortlisted': { 
        color: 'success', 
        icon: <CheckCircle fontSize="small" />,
        bgcolor: '#e8f5e9',
        textColor: '#2e7d32'
      },
      'interest confirmed': {
        color: 'success', 
        icon: <CheckCircle fontSize="small" />,
        bgcolor: '#e8eaf6',
        textColor: '#3949ab'
      },
      'not interested': {
        color: 'default', 
        icon: <Cancel fontSize="small" />,
        bgcolor: '#f5f5f5',
        textColor: '#757575'
      },
      'interview scheduled': { 
        color: 'info', 
        icon: <Schedule fontSize="small" />,
        bgcolor: '#e3f2fd',
        textColor: '#1565c0'
      },
      'interview completed': { 
        color: 'primary', 
        icon: <AssignmentTurnedIn fontSize="small" />,
        bgcolor: '#e8eaf6',
        textColor: '#3949ab'
      },
      'selected': { 
        color: 'success', 
        icon: <CheckCircle fontSize="small" />,
        bgcolor: '#c8e6c9',
        textColor: '#1b5e20'
      },
      'rejected': { 
        color: 'error', 
        icon: <Cancel fontSize="small" />,
        bgcolor: '#ffebee',
        textColor: '#c62828'
      }
    };

    const config = statusColors[normalizedStatus] || { 
      color: 'default', 
      icon: <Pending fontSize="small" />,
      bgcolor: '#f5f5f5',
      textColor: '#616161'
    };

    const displayStatus = status 
      ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
      : 'Pending';

    return (
      <Chip 
        label={displayStatus}
        size="small"
        icon={config.icon}
        sx={{ 
          fontWeight: 'bold',
          backgroundColor: config.bgcolor,
          color: config.textColor,
          border: `1px solid ${config.textColor}`,
          '& .MuiChip-icon': {
            color: config.textColor
          }
        }}
      />
    );
  };

  return (
    <Container maxWidth="1500px" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ 
        p: 4, 
        borderRadius: 2,
        border: '2px solid',
        borderColor: 'grey.300',
        boxShadow: 4
      }}>
        <Typography variant="h4" gutterBottom  fontWeight="bold">
          Candidate Filter
        </Typography>
        
        {/* Shortlisting Options - Two Buttons in Same Line */}
        {/* <Box sx={{ 
          display: "flex", 
          justifyContent: "center", 
          gap: 3, 
          mb: 3,
          p: 3,
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          borderRadius: 2,
          boxShadow: 2
        }}>
          <Box sx={{ 
            flex: 1, 
            p: 3, 
            borderRadius: 2, 
            bgcolor: 'white',
            boxShadow: 2,
            border: shortlistMode === 'ai' ? '3px solid #667eea' : '1px solid #e0e0e0'
          }}>
             <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              AI analyzes candidates based on skills, experience, and job requirements to shortlist the best matches.
            </Typography>
         
            <Button
              variant={shortlistMode === 'ai' ? "contained" : "outlined"}
              color="primary"
              size="large"
              fullWidth
              startIcon={shortlistLoading ? <CircularProgress size={20} color="inherit" /> : <AutoAwesome />}
              onClick={() => {
                setShortlistMode('ai');
                if (!shortlistLoading) handleOpenShortlistDialog();
              }}
              disabled={shortlistLoading || candidates.length === 0}
              sx={{ 
                fontWeight: 'bold',
                boxShadow: shortlistMode === 'ai' ? 3 : 0,
                mt: 1
              }}
            >
              {shortlistLoading ? 'AI Processing...' : 'AI Auto-Shortlist'}
            </Button>
            
            {shortlistLoading && (
              <Box sx={{ width: '100%', mt: 2 }}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  {shortlistProgress}
                </Typography>
                <LinearProgress />
              </Box>
            )}
          </Box>
          
          <Box sx={{ 
            flex: 1, 
            p: 3, 
            borderRadius: 2, 
            bgcolor: 'white',
            boxShadow: 2,
            border: shortlistMode === 'manual' ? '3px solid #20c997' : '1px solid #e0e0e0'
          }}>
          
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Manually select candidates to shortlist. Review each candidate's profile before selecting.
            </Typography>
            <Button
              variant={shortlistMode === 'manual' ? "contained" : "outlined"}
              color="success"
              size="large"
              fullWidth
              startIcon={manualShortlistLoading ? <CircularProgress size={20} color="inherit" /> : <HowToReg />}
              onClick={() => {
                setShortlistMode('manual');
                if (!manualShortlistLoading) handleOpenManualShortlistDialog();
              }}
              disabled={manualShortlistLoading}
              sx={{ 
                fontWeight: 'bold',
                boxShadow: shortlistMode === 'manual' ? 3 : 0,
                mt: 1
              }}
            >
              {manualShortlistLoading ? 'Processing...' : 'Manual Shortlist'}
            </Button>
          </Box>
        </Box> */}

<Box sx={{ 
  display: "flex", 
  justifyContent: "center", 
  gap: 3, 
  mb: 3,
  p: 3,
  background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
  borderRadius: 2,
  boxShadow: 2
}}>
  
  {/* NEW: DISCOVER BUTTON */}
<Box sx={{ 
  flex: 1, 
  p: 3, 
  borderRadius: 2, 
  bgcolor: 'white',
  boxShadow: 2,
  border: shortlistMode === 'discover' ? '3px solid #ff9800' : '1px solid #e0e0e0'
}}>
  <Typography variant="h6" gutterBottom fontWeight="bold" color="#ff9800">
    🔍 Discover Candidates
  </Typography>
  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
    Search Google for candidates matching your job requirements. Review results before parsing.
  </Typography>
  
  <Button
    variant="contained"
    fullWidth
    startIcon={discoverLoading ? <CircularProgress size={20} /> : <Search />}
    onClick={() => setDiscoverDialogOpen(true)}
    disabled={discoverLoading}
    sx={{ 
      bgcolor: '#ff9800', 
      '&:hover': { bgcolor: '#f57c00' },
      fontWeight: 'bold'
    }}
  >
    {discoverLoading ? 'Searching...' : 'Start Discovery'}
  </Button>
</Box>
  
  {/* AI Auto-Shortlist Button (your existing) */}
  <Box sx={{ 
    flex: 1, 
    p: 3, 
    borderRadius: 2, 
    bgcolor: 'white',
    boxShadow: 2,
    border: shortlistMode === 'ai' ? '3px solid #667eea' : '1px solid #e0e0e0'
  }}>
    <Typography variant="h6" gutterBottom fontWeight="bold" color="#667eea">
      🤖 AI Auto-Shortlist
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      AI analyzes candidates based on skills, experience, and job requirements.
    </Typography>
    <Button
      variant={shortlistMode === 'ai' ? "contained" : "outlined"}
      color="primary"
      size="large"
      fullWidth
      startIcon={shortlistLoading ? <CircularProgress size={20} color="inherit" /> : <AutoAwesome />}
      onClick={() => {
        setShortlistMode('ai');
        if (!shortlistLoading) handleOpenShortlistDialog();
      }}
      disabled={shortlistLoading || candidates.length === 0}
    >
      {shortlistLoading ? 'AI Processing...' : 'AI Auto-Shortlist'}
    </Button>
  </Box>
  
  {/* Manual Shortlisting Button (your existing) */}
  <Box sx={{ 
    flex: 1, 
    p: 3, 
    borderRadius: 2, 
    bgcolor: 'white',
    boxShadow: 2,
    border: shortlistMode === 'manual' ? '3px solid #20c997' : '1px solid #e0e0e0'
  }}>
    <Typography variant="h6" gutterBottom fontWeight="bold" color="#20c997">
      👤 Manual Shortlist
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Manually select candidates to shortlist. Review each candidate's profile.
    </Typography>
    <Button
      variant={shortlistMode === 'manual' ? "contained" : "outlined"}
      color="success"
      size="large"
      fullWidth
      startIcon={manualShortlistLoading ? <CircularProgress size={20} color="inherit" /> : <HowToReg />}
      onClick={() => {
        setShortlistMode('manual');
        if (!manualShortlistLoading) handleOpenManualShortlistDialog();
      }}
      disabled={manualShortlistLoading}
    >
      {manualShortlistLoading ? 'Processing...' : 'Manual Shortlist'}
    </Button>
  </Box>
</Box>
        {/* Filter Section */}
        <Box display="flex" gap={2} marginBottom={2}>
          <FormControl fullWidth>
            <InputLabel>Skills</InputLabel>
            <Select 
              name="skills" 
              label="Skills" 
              value={filters.skills} 
              onChange={handleChange}
              endAdornment={
                <InputAdornment position="end" sx={{ position: 'absolute', right: 28, pointerEvents: 'none' }}>
                  <Button 
                    onClick={handleOpenAddSkillDialog}
                    sx={{ minWidth: 'auto', pointerEvents: 'auto' }}
                  >
                    <Add />
                  </Button>
                </InputAdornment>
              }
            >
              {availableSkills.sort().map((skill) => (
                <MenuItem key={skill} value={skill}>{skill}</MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <FormControl fullWidth>
            <InputLabel>Experience (Years)</InputLabel>
            <Select
              name="experience"
              label="Experience (Years)"
              value={filters.experience}
              onChange={handleChange}
            >
              {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].map((year) => (
                <MenuItem key={year} value={year}>{year} years</MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <Box sx={{ width: "180px", height: "40px", paddingTop: "10px" }}>
            <Button
              variant="contained"
              onClick={filterCandidates}
              fullWidth
            >
              Filter
            </Button>
          </Box>
        </Box>

        {/* Search Box */}
        <Box sx={{ display: "flex", marginBottom: 2 }}>
          <TextField
            label="Search candidates"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{ mb: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <hr style={{ margin: "20px 0", border: "1px solid gray" }} />
        
        {loading && <CircularProgress />}
        {error && <Alert severity="error" onClose={() => setError("")}>{error}</Alert>}

        {!loading && !error && (
          <>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    {shortlistMode === 'manual' && (
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectAll}
                          onChange={handleSelectAll}
                          indeterminate={selectedCandidates.length > 0 && selectedCandidates.length < allFilteredCandidates.length}
                          icon={<CheckBoxOutlineBlank />}
                          checkedIcon={<CheckBox />}
                        />
                      </TableCell>
                    )}
                    <TableCell><Person fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />Name</TableCell>
                    <TableCell><Email fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />Email</TableCell>
                    <TableCell><Phone fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />Phone</TableCell>
                    <TableCell><WorkHistory fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />Job Title</TableCell>
                    <TableCell><Code fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />Skills</TableCell>
                    <TableCell><WorkHistory fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />Experience</TableCell>
                    <TableCell><CheckCircle fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />Status</TableCell>
                    <TableCell><PersonAdd fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />Referred</TableCell>
                    <TableCell><Description fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />Resume</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {candidates.length > 0 ? (
                    candidates.map((candidate) => {
                      const statusLower = (candidate.status || '').toLowerCase().trim();
                      const showScheduleButton = !['pending', 'shortlisted', 'not interested'].includes(statusLower);
                      const isEligibleForShortlisting = !['shortlisted', 'interest confirmed', 'not interested', 'interview scheduled', 'interview completed', 'selected', 'rejected'].includes(statusLower);
                      
                      return (
                        <TableRow key={candidate.email}>
                          {shortlistMode === 'manual' && (
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={selectedCandidates.includes(candidate.email)}
                                onChange={() => handleSelectCandidate(candidate.email)}
                                disabled={!isEligibleForShortlisting}
                                icon={<CheckBoxOutlineBlank />}
                                checkedIcon={<CheckBox />}
                              />
                            </TableCell>
                          )}
                          <TableCell>{candidate.name}</TableCell>
                          <TableCell>{candidate.email}</TableCell>
                          <TableCell>{candidate.phone}</TableCell>
                          <TableCell>{candidate.positionApplied || 'N/A'}</TableCell>
                          <TableCell>{candidate.skills.join(", ")}</TableCell>
                          <TableCell>{candidate.experience} years</TableCell>
                          <TableCell>
                            {getStatusChip(candidate.status || 'pending')}
                          </TableCell>
                          <TableCell>
                            {candidate.referrerName ? (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Chip 
                                  label="Yes" 
                                  color="success" 
                                  size="small"
                                />
                                <Tooltip title="View Referrer Details">
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => handleShowReferrerDetails(candidate)}
                                  >
                                    <Info fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            ) : (
                              <Chip label="No" color="default" size="small" />
                            )}
                          </TableCell>
                          <TableCell>
                            <Tooltip title={(!candidate.resumePath || candidate.resumePath === 'N/A' || candidate.resumePath === 'false') ? "No Resume Available" : "View Resume"}>
                              <span>
                                <IconButton
                                  color={(!candidate.resumePath || candidate.resumePath === 'N/A' || candidate.resumePath === 'false') ? "default" : "primary"}
                                  onClick={() => handleViewResume(candidate)}
                                  disabled={(!candidate.resumePath || candidate.resumePath === 'N/A' || candidate.resumePath === 'false') || resumeLoading === candidate.email}
                                >
                                  {resumeLoading === candidate.email ? (
                                    <CircularProgress size={20} />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            {showScheduleButton ? (
                              <Button variant="contained" onClick={() => scheduleInterview(candidate)}>
                                Schedule Interview
                              </Button>
                            ) : (
                              <Tooltip title={`Cannot schedule: Status is "${candidate.status}"`}>
                                <span>
                                  <Button variant="outlined" disabled>
                                    {statusLower === 'interview scheduled' ? 'Already Scheduled' : 'Not Available'}
                                  </Button>
                                </span>
                              </Tooltip>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={shortlistMode === 'manual' ? 11 : 10} align="center">
                        No candidates found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {totalPages > 1 && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                />
              </Box>
            )}
          </>
        )}

        {/* Add Skill Dialog */}
        <Dialog open={openAddSkillDialog} onClose={handleCloseAddSkillDialog}>
          <DialogTitle>Add New Skill</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Skill Name"
              type="text"
              fullWidth
              variant="outlined"
              value={newSkill}
              onChange={handleNewSkillChange}
              error={!!skillError}
              helperText={skillError}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAddSkillDialog}>Cancel</Button>
            <Button 
              onClick={handleAddSkill} 
              variant="contained" 
              disabled={!newSkill.trim() || !!skillError}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>

        {/* Job Selection Dialog for AI Shortlisting */}
        <Dialog open={openJobSelectDialog} onClose={handleCloseJobSelectDialog} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
             Select Job Position for AI Shortlisting
          </DialogTitle>
          <DialogContent sx={{ mt: 2 }}>
            <FormControl fullWidth>
              <InputLabel>Job Position</InputLabel>
              <Select
                value={selectedJobForShortlist}
                onChange={(e) => setSelectedJobForShortlist(e.target.value)}
                label="Job Position"
              >
                {availableJobs.map((job) => (
                  <MenuItem key={job} value={job}>
                    {job}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">Current Filters (Optional – Refines Shortlist):</Typography>
              <FormControl fullWidth sx={{ mt: 1 }}>
                <InputLabel>Skills</InputLabel>
                <Select
                  value={filters.skills || ''}
                  label="Skills"
                  onChange={(e) => setFilters({ ...filters, skills: e.target.value })}
                >
                  <MenuItem value="">No Filter</MenuItem>
                  {availableSkills.sort().map((skill) => (
                    <MenuItem key={skill} value={skill}>{skill}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mt: 1 }}>
                <InputLabel>Min Experience (Years)</InputLabel>
                <Select
                  value={filters.experience || ''}
                  label="Min Experience"
                  onChange={(e) => setFilters({ ...filters, experience: e.target.value })}
                >
                  <MenuItem value="">No Filter</MenuItem>
                  {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].map((year) => (
                    <MenuItem key={year} value={year}>{year} years</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 2, p: 2, bgcolor: 'info.light', borderRadius: 1 }}>
              💡 <strong>AI will automatically:</strong>
              <br/>• Analyze filtered candidates for this position
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseJobSelectDialog}>Cancel</Button>
            <Button 
              onClick={() => handleAutoShortlist()}
              variant="contained"
              color="success"
              disabled={!selectedJobForShortlist}
              startIcon={<AutoAwesome />}
            >
              Start AI Shortlisting
            </Button>
          </DialogActions>
        </Dialog>

        {/* Manual Shortlisting Dialog */}
        <Dialog 
          open={openManualShortlistDialog} 
          onClose={handleCloseManualShortlistDialog}
          maxWidth="md"
          fullWidth
          maxHeight="80vh"
        >
          <DialogTitle sx={{ 
            bgcolor: '#20c997', 
            color: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Typography variant="h6">Manual Shortlisting</Typography>
            <Chip 
              label={`${selectedCandidates.length} selected`}
              sx={{ bgcolor: 'white', color: '#20c997', fontWeight: 'bold' }}
            />
          </DialogTitle>
          
          <DialogContent sx={{ mt: 2, maxHeight: '60vh', overflow: 'auto' }}>
            {/* Job Selection */}
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel>Select Job Position *</InputLabel>
              <Select
                value={selectedJobForShortlist}
                onChange={(e) => setSelectedJobForShortlist(e.target.value)}
                label="Select Job Position *"
              >
                <MenuItem value="" disabled>Select a job position</MenuItem>
                {availableJobs.map((job) => (
                  <MenuItem key={job} value={job}>
                    {job}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Select All Checkbox */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, p: 1, bgcolor: '#f8f9fa', borderRadius: 1 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectAll}
                    onChange={handleSelectAll}
                    icon={<CheckBoxOutlineBlank />}
                    checkedIcon={<CheckBox />}
                  />
                }
                label="Select All Eligible Candidates"
              />
              <Typography variant="caption" color="text.secondary" sx={{ ml: 2 }}>
                ({allFilteredCandidates.filter(c => {
                  const statusLower = (c.status || '').toLowerCase().trim();
                  return !['shortlisted', 'interest confirmed', 'not interested', 'interview scheduled', 'interview completed', 'selected', 'rejected'].includes(statusLower);
                }).length} eligible)
              </Typography>
            </Box>

            {/* Candidate List */}
            <List sx={{ width: '100%' }}>
              {allFilteredCandidates.map((candidate) => {
                const statusLower = (candidate.status || '').toLowerCase().trim();
                const isEligible = !['shortlisted', 'interest confirmed', 'not interested', 'interview scheduled', 'interview completed', 'selected', 'rejected'].includes(statusLower);
                
                return (
                  <ListItem
                    key={candidate.email}
                    sx={{
                      borderBottom: '1px solid #e0e0e0',
                      bgcolor: isEligible ? 'white' : '#f5f5f5',
                      opacity: isEligible ? 1 : 0.6
                    }}
                    secondaryAction={
                      <Checkbox
                        checked={selectedCandidates.includes(candidate.email)}
                        onChange={() => handleSelectCandidate(candidate.email)}
                        disabled={!isEligible}
                        icon={<CheckBoxOutlineBlank />}
                        checkedIcon={<CheckBox />}
                      />
                    }
                  >
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Typography variant="subtitle1" fontWeight="medium">
                            {candidate.name}
                          </Typography>
                          {getStatusChip(candidate.status || 'pending')}
                        </Box>
                      }
                      secondary={
                        <Box sx={{ mt: 1 }}>
                          <Typography variant="body2" color="text.secondary">
                            Email: {candidate.email} | Phone: {candidate.phone}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Position: {candidate.positionApplied || 'N/A'} | Experience: {candidate.experience} years
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Skills: {candidate.skills.join(", ")}
                          </Typography>
                          {!isEligible && (
                            <Typography variant="caption" color="error" sx={{ display: 'block', mt: 0.5 }}>
                              Not eligible for shortlisting (current status: {candidate.status || 'pending'})
                            </Typography>
                          )}
                        </Box>
                      }
                    />
                  </ListItem>
                );
              })}
            </List>

            {/* Summary */}
            {selectedCandidates.length > 0 && (
              <Box sx={{ 
                mt: 3, 
                p: 2, 
                bgcolor: '#e8f5e9', 
                borderRadius: 1,
                border: '1px solid #c8e6c9'
              }}>
                <Typography variant="subtitle1" fontWeight="bold" color="#2e7d32" gutterBottom>
                  📋 Shortlisting Summary
                </Typography>
                <Typography variant="body2">
                  • <strong>{selectedCandidates.length}</strong> candidate(s) selected for shortlisting
                </Typography>
                <Typography variant="body2">
                  • Job Position: <strong>{selectedJobForShortlist || 'Not selected'}</strong>
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Selected candidates will receive notification emails and their status will be updated to "Shortlisted".
                </Typography>
              </Box>
            )}
          </DialogContent>
          
          <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}>
            <Button onClick={handleCloseManualShortlistDialog} color="inherit">
              Cancel
            </Button>
            <Button
              onClick={handleManualShortlist}
              variant="contained"
              color="success"
              disabled={selectedCandidates.length === 0 || !selectedJobForShortlist || manualShortlistLoading}
              startIcon={manualShortlistLoading ? <CircularProgress size={20} /> : <HowToReg />}
              sx={{ 
                bgcolor: '#20c997',
                '&:hover': { bgcolor: '#1ba87e' }
              }}
            >
              {manualShortlistLoading ? 'Processing...' : `Shortlist ${selectedCandidates.length} Candidate(s)`}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Referrer Details Dialog */}
        <Dialog 
          open={openReferrerDialog} 
          onClose={handleCloseReferrerDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Referrer Details</Typography>
            <IconButton
              onClick={handleCloseReferrerDialog}
              size="small"
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {selectedCandidate && (
              <Box sx={{ py: 2 }}>
                <Typography variant="subtitle1" gutterBottom color="primary" fontWeight="bold">
                  Candidate: {selectedCandidate.name}
                </Typography>
                
                <Box sx={{ mt: 3 }}>
                  <Typography variant="h6" gutterBottom color="text.primary">
                    Referred By:
                  </Typography>
                  
                  <Box sx={{ pl: 2, borderLeft: 3, borderColor: 'primary.main', bgcolor: 'grey.50', p: 2, borderRadius: 1 }}>
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary">Name:</Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {selectedCandidate.referrerName || 'N/A'}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary">Email:</Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {selectedCandidate.referrerEmail || 'N/A'}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary">Relation:</Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {selectedCandidate.referrerRelation || 'N/A'}
                      </Typography>
                    </Box>
                    
                    {selectedCandidate.referralreason && (
                      <Box>
                        <Typography variant="subtitle2" color="text.secondary">Referral Reason:</Typography>
                        <Typography variant="body1" sx={{ mt: 1, bgcolor: 'white', p: 1.5, borderRadius: 1, border: 1, borderColor: 'grey.300' }}>
                          {selectedCandidate.referralreason}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseReferrerDialog} variant="contained">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
      <DiscoveryDialog
  open={discoverDialogOpen}
  onClose={() => setDiscoverDialogOpen(false)}
  onSearch={handleDiscover}
/>
      <Snackbar 
        open={alert.open} 
        autoHideDuration={6000} 
        onClose={() => setAlert(prev => ({ ...prev, open: false }))} 
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert 
          onClose={() => setAlert(prev => ({ ...prev, open: false }))} 
          severity={alert.severity}
          sx={{ width: '100%', boxShadow: 3 }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default CandidateFilter;